"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Key = void 0;
const util_1 = require("./util");
class Key {
    static fromEvent(event) {
        const parts = [];
        if (event.altKey)
            parts.push('Alt');
        if (event.ctrlKey)
            parts.push('Control');
        if (event.metaKey)
            parts.push('Meta');
        if (event.shiftKey)
            parts.push('Shift');
        const mod = parts.join('+');
        return new Key(event.key ?? '', Date.now(), mod, event, event.code);
    }
    constructor(key, ts, mod = '', event, code) {
        this.key = key;
        this.ts = ts;
        this.mod = mod;
        this.event = event;
        this.code = code;
        this.propagate = true;
    }
    sig() {
        const mod = this.mod;
        let key = this.key;
        if (key === ' ')
            key = 'Space';
        else if (key.length === 1)
            key = key.toLowerCase();
        const repeat = this.event?.repeat ? ':R' : '';
        // When the key itself is a modifier already present in the prefix, omit
        // the redundant key portion (e.g. pressing Shift alone: 'Shift', not 'Shift+Shift').
        if (mod && (0, util_1.isMod)(key))
            return (mod + repeat);
        const prefix = mod ? mod + '+' : '';
        return (prefix + key + repeat);
    }
    /** Builds a signature from `event.code` (physical key position). */
    codeSig() {
        const code = this.code;
        if (!code)
            return this.sig();
        const mod = this.mod;
        const prefix = mod ? mod + '+' : '';
        const repeat = this.event?.repeat ? ':R' : '';
        return prefix + '@' + code + repeat;
    }
}
exports.Key = Key;
